import mitt from 'mitt'
const m = mitt()
export default m
